import { useTranslation } from 'libs/i18n'
import { routes } from 'config/routes'
import type { Tab } from 'shared/components/Form/types'

export const useBookingEngineTabs = (): Tab[] => {
	const { t } = useTranslation()

	return [
		{ label: t('Coupons'), value: routes.couponIndex },
		{ label: t('Area types'), value: routes.areaTypeIndex },
		{ label: t('Areas'), value: routes.areaIndex },
		{ label: t('Store map'), value: routes.floorMapIndex },
		{ label: t('Rental'), value: routes.rentalIndex },
		{ label: t('Opening hours'), value: routes.openingHourIndex }
	]
}
